// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productCountStyles } from "@conklin/Overrides/Widgets/ProductList/ProductListProductCount";
import { DivWrapper } from "@conklin/XDL/constants";
import { mergeWithCss } from "@conklin/XDL/Utilities";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

const sharedTextStyles: TypographyPresentationProps = {
    variant: "h3",
    forwardAs: "p",
    css: css`
        line-height: 22px;
    `,
};

productCountStyles.wrapper = {
    css: css`
        display: flex;
        padding-bottom: 12px;
        align-items: baseline;
        flex-wrap: wrap;
    `,
};

productCountStyles.queryText = {
    variant: "h1",
    color: "text",
    css: css`
        word-break: break-word;
    `,
};

productCountStyles.resultsForText = {
    ...mergeWithCss(sharedTextStyles, {
        css: css`
            &:after {
                content: ":";
            }
        `,
    }),
};

productCountStyles.countText = {
    ...mergeWithCss(sharedTextStyles, {
        css: css`
            padding-top: 24px;
            margin-bottom: 0;
        `,
    }),
};

productCountStyles.content = {
    css: css`
        width: 100%;
        > ${DivWrapper} {
            display: flex;
            flex-direction: column;
            gap: 24px;
            > div:empty {
                display: none;
            }
        }
        &:has(> ${DivWrapper}:empty) {
            display: none;
        }
    `,
};
